import React from "react";
import styles from "./Tag.module.css";

interface TagProps {
    text: string;
    onRemove?: () => void;
    color?: string;
    backgroundColor?: string;
    className?: string;
}

const Tag: React.FC<TagProps> = ({
    text,
    onRemove,
    color = "var(--brand-fg)",
    backgroundColor = "var(--brand)",
    className = "",
}) => {
    return (
        <div
            className={[
                styles.root,
                className.includes("tag--locked") ? styles.locked : "",
                className !== "tag--locked" ? className : "",
            ]
                .filter(Boolean)
                .join(" ")}
            style={{
                backgroundColor,
                color,
            }}
        >
            <span>{text}</span>
            {onRemove && (
                <span className={styles.remove} onClick={onRemove}>
                    ×
                </span>
            )}
        </div>
    );
};

export default Tag;
